import { view } from "@/mega-ui/helpers/function"
import { checkUserRoleGuard } from "@/helpers/routerHelpers"

export const bills = {
    path: '/bills',
    name: 'bills',
    children: [
        {
            path: 'main',
            name: 'bills-main',
            beforeEnter: [ checkUserRoleGuard ],
            meta: {
                withAuth: true
            },
            component: () => view('bills/BillsMainView')
        },
    ]
}